module.exports = __webpack_public_path__ + "static/media/dummy_medium.3d867762.png";